module.exports = __webpack_public_path__ + "img/img_half_slim.b66b87e7.png";